import { Action } from 'redux';

import { InvitationType } from 'common/enums/invitation-type';
import { RoleGroup } from 'common/enums/role-group';
import { ActionWith } from 'common/interfaces/action-with';
import { InvitationCompanyUsers } from 'unit-people/interfaces/invitation-company-users';
import { UserInfo } from 'unit-people/interfaces/user-info';
import {
  CompanySubscriptionUsersChangedModel,
} from '../../../units/account/interfaces/company-subscription-users-changed-model';
import { InvitationInfo } from '../interfaces/invitation-info';
import { Person } from '../interfaces/person';
import * as Payloads from './payloads';
import { PeopleActionTypes } from './types';

function getCompanyPeople(): Action {
  return {
    type: PeopleActionTypes.COMPANY_PEOPLE_GET_REQUEST,
  };
}

function getCompanyPeopleSucceeded(companyId: number, people: Person[]): ActionWith<Payloads.CompanyUsersPayload> {
  return {
    type: PeopleActionTypes.COMPANY_PEOPLE_GET_SUCCEEDED,
    payload: { companyId, people },
  };
}

function setPeopleFilter(filter: string): ActionWith<string> {
  return {
    type: PeopleActionTypes.SET_FILTER,
    payload: filter,
  };
}

function invitePeopleToCompanyNew(
  invites: InvitationCompanyUsers[],
): ActionWith<InvitationCompanyUsers[]> {
  return {
    type: PeopleActionTypes.INVITE_TO_COMPANY,
    payload: invites,
  };
}

function invitePeopleToCompany(): Action {
  return {
    type: PeopleActionTypes.INVITE_TO_COMPANY_REQUEST,
  };
}

function tryConfirmInvite(
  token: string,
  invitationType: InvitationType,
): ActionWith<Payloads.InviteInfo> {
  return {
    type: PeopleActionTypes.INVITE_INFO_GET_REQUEST,
    payload: {
      token,
      invitationType,
    },
  };
}

function confirmInvitation(
  token: string,
  invitationType: InvitationType,
): ActionWith<Payloads.InviteInfo> {
  return {
    type: PeopleActionTypes.INVITE_CONFIRM_REQUEST,
    payload: {
      token,
      invitationType,
    },
  };
}

function inviteGetInfoSuccessed(
  data: InvitationInfo,
): ActionWith<InvitationInfo> {
  return {
    type: PeopleActionTypes.INVITE_INFO_GET_SUCCEEDED,
    payload: data,
  };
}

function saveUserMap(map: Record<string, UserInfo>): ActionWith<Record<string, UserInfo>> {
  return {
    type: PeopleActionTypes.SAVE_USER_MAP,
    payload: map,
  };
}

function addToUserMap(user: Record<string, UserInfo>): ActionWith<Record<string, UserInfo>> {
  return {
    type: PeopleActionTypes.ADD_TO_USER_MAP,
    payload: user,
  };
}

function deleteCompanyPerson(userId: string): ActionWith<string> {
  return {
    type: PeopleActionTypes.DELETE_COMPANY_PERSON_REQUEST,
    payload: userId,
  };
}

function changeDisplayedRoleGroup(
  roleGroup: RoleGroup | null,
): ActionWith<RoleGroup | null> {
  return {
    type: PeopleActionTypes.CHANGE_DISPLAYED_ROLE_GROUP,
    payload: roleGroup,
  };
}

function resendInvitation(userId: string): ActionWith<string> {
  return {
    type: PeopleActionTypes.RESEND_INVITATION_REQUEST,
    payload: userId,
  };
}

function resendInvitationSucceeded(
  companyId: number,
  invitationToken: string,
): ActionWith<Payloads.CompanyUserInvitationTokenPayload> {
  return {
    type: PeopleActionTypes.RESEND_INVITATION_SUCCEEDED,
    payload: { companyId, userId: invitationToken },
  };
}

function updateUserRole(userId: string, companyId: number, roleId: number): ActionWith<Payloads.UpdateUserRolePayload> {
  return {
    type: PeopleActionTypes.UPDATE_USER_ROLE_REQUEST,
    payload: {
      userId,
      companyId,
      roleId,
    },
  };
}

function updateUserRoleSucceeded(
  userId: string,
  companyId: number,
  roleId: number,
): ActionWith<Payloads.UpdateUserRolePayload> {
  return {
    type: PeopleActionTypes.UPDATE_USER_ROLE_SUCCEEDED,
    payload: {
      userId,
      companyId,
      roleId,
    },
  };
}

function dropInviteInfo(): Action {
  return {
    type: PeopleActionTypes.DROP_INVITE_INFO,
  };
}

function updateCompanySubscriptionUsers(
  model: CompanySubscriptionUsersChangedModel,
): ActionWith<CompanySubscriptionUsersChangedModel> {
  return {
    type: PeopleActionTypes.UPDATE_SUBSCRIPTION_USERS,
    payload: model,
  };
}


function dropPeopleState(): Action {
  return {
    type: PeopleActionTypes.DROP_PEOPLE_STATE,
  };
}


export const PeopleActions = {
  getCompanyPeople,
  getCompanyPeopleSucceeded,
  setPeopleFilter,
  invitePeopleToCompany,
  tryConfirmInvite,
  confirmInvitation,
  inviteGetInfoSuccessed,
  saveUserMap,
  addToUserMap,
  deleteCompanyPerson,
  changeDisplayedRoleGroup,
  resendInvitation,
  resendInvitationSucceeded,
  updateUserRole,
  updateUserRoleSucceeded,
  dropInviteInfo,
  invitePeopleToCompanyNew,
  updateCompanySubscriptionUsers,
  dropPeopleState,
};
